export default __webpack_public_path__ + "static/media/Neophyte's Hood of Prestige.f5da3ffd.jpg";